import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
// import Table from './Table';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  IconButton,
  Typography
} from '@material-ui/core';
import MuiDialogContent from '@material-ui/core/DialogContent';
// import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import * as constants from '../../../common/constants';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[700]
  },
  table: {
    width: 'max-content'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content'
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={(event) => {
            event.stopPropagation();
            onClose(event);
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogContent);

// const DialogActions = withStyles((theme) => ({
//   root: {
//     margin: 0,
//     padding: theme.spacing(1)
//   }
// }))(MuiDialogActions);

@inject('booksStatus')
@observer
class BookHistory extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    bookHistory: PropTypes.array.isRequired,
    dialogClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  componentDidMount() {}

  handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ open: false });
    const { dialogClose } = this.props;
    dialogClose();
  };

  render() {
    const { classes, bookHistory } = this.props;
    const { open } = this.state;
    const showSourceEpubColumn = bookHistory.some((row) => row.titleType === constants.ETEXT2_PXE_TITLE);

    return (
      <div>
        <Dialog maxWidth="true" onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={open}>
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            Book History
          </DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date/Time</TableCell>
                      <TableCell align="center">User</TableCell>
                      <TableCell align="center">BookID</TableCell>
                      <TableCell align="center">Version</TableCell>
                      {showSourceEpubColumn && <TableCell align="center">Source ePub</TableCell>}
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bookHistory.map((row) => {
                      let bookIdDisplay = row.bookID;
                      if (row.titleType === constants.ETEXT2_PXE_TITLE && row.epubBookID !== null) {
                        bookIdDisplay = row.epubBookID;
                      } else if (row.titleType === constants.ETEXT2_PXE_TITLE && row.epubBookID === null) {
                        if (row.pulseBookID && row.pulseBookID.includes('-REV')) {
                          bookIdDisplay = row.pulseBookID;
                        } else {
                          bookIdDisplay = row.pulseBookID ? `${row.pulseBookID}-REV` : row.pulseBookID;
                        }
                      } else if (
                        row.titleType === constants.RPLUS_PDF_TITLE ||
                        row.titleType === constants.RPLUS_EPUB_TITLE
                      )
                        bookIdDisplay = row.pulseBookID;
                      return (
                        <TableRow key={row.user}>
                          <TableCell component="th" scope="row">
                            {row.updatedDate}
                          </TableCell>
                          <TableCell align="left" nowrap>
                            {row.name}
                          </TableCell>
                          <TableCell align="center">{bookIdDisplay}</TableCell>
                          <TableCell align="center">{row.version}</TableCell>
                          {showSourceEpubColumn && (
                            <TableCell align="center">
                              {row.titleType === constants.ETEXT2_PXE_TITLE ? row.sourceEpub : ''}
                            </TableCell>
                          )}
                          <TableCell align="left">{row.status}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Typography>
          </DialogContent>
          {/* <DialogActions>
            <Button autoFocus onClick={this.handleClose} variant="outlined" color="primary">
            Export book history
            </Button>
          </DialogActions> */}
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(observer(inject('language')(BookHistory)));
